import * as React from 'react';
import Modal from 'react-modal';

import DeviceSettingsItemTemplate from './DeviceSettingsItemTemplate';
import { DeviceSettingsDevice } from '../DeviceSettings';
import RemoveDeviceFromUserConfirmDialog from 'settings/components/RemoveDeviceFromUserConfirmDialog';

export type Props = {
  landlineDevice: DeviceSettingsDevice;
  isRosteredEnforcement: boolean;
};

type State = {
  confirmRemoveDialogIsOpen: boolean;
};

export default class DeviceSettingsLandlineItem extends React.Component<Props, State> {
  state = {
    confirmRemoveDialogIsOpen: false,
  };

  showConfirmRemoveDialog = () => {
    this.setState({ confirmRemoveDialogIsOpen: true });
  };

  hideConfirmRemoveDialog = () => {
    this.setState({ confirmRemoveDialogIsOpen: false });
  };

  render() {
    const { landlineDevice, isRosteredEnforcement } = this.props;

    return (
      <React.Fragment>
        <Modal
          data-test="remove-landline-device-modal"
          isOpen={this.state.confirmRemoveDialogIsOpen}>
          <RemoveDeviceFromUserConfirmDialog
            deviceName={landlineDevice.label || 'Your device'}
            deviceId={landlineDevice.id}
            onRequestHide={this.hideConfirmRemoveDialog}
          />
        </Modal>
        <DeviceSettingsItemTemplate
          deviceType="landline"
          deviceExists
          deviceIsRostered={landlineDevice.rostered && isRosteredEnforcement}
          deviceCanBeEnabledOrDisabled={false}
          primaryTextLabel={landlineDevice.label}
          secondaryTextLabel="Landlines only receive urgent text-to-voice messages and voice calls"
          onRemoveDevice={this.showConfirmRemoveDialog}
        />
      </React.Fragment>
    );
  }
}
